import builder from '../builder';
import EmailActionReply from '../../streamline-icons/light/email-action-reply.svg';

export default builder('IconEmailActionReplyLight', EmailActionReply);
